import { render, staticRenderFns } from "./SafeSettings.vue?vue&type=template&id=47d96418&scoped=true&"
import script from "./SafeSettings.vue?vue&type=script&lang=js&"
export * from "./SafeSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d96418",
  null
  
)

export default component.exports